<woa-modal-page-layout [title]="'woa.heading.order.plgEdit'"
                       [translationParams]="{'plgName': plgItem().plg.externalName || plgItem().plg.name}">
    <div class="items" [ngClass]="{'with-images': anyHaveImages()}">
        @for (plgSellable of availablePlgSellables(); track plgSellable; let i = $index) {
            <div class="item" id="item-{{i}}">
                <woa-order-item-option-control [image]="menuModel.getMenuItemProductImage(plgSellable.menuItem)"
                                               [title]="menuModel.getMenuItemDisplayName(plgSellable.menuItem) || plgSellable.sellable.name"
                                               [price]="plgSellable.additionalPrice"
                                               [showImage]="anyHaveImages()"
                                               [unavailable]="showPlgSellableUnavailable()(plgSellable)"
                                               [selected]="isPlgSellableSelected()(plgSellable)"
                                               (onSelect)="selectPlgSellable(plgSellable)">
                    <woa-dietary-panel [sellable]="plgSellable.sellable"></woa-dietary-panel>
                </woa-order-item-option-control>
            </div>
        }
    </div>
    <woa-button woa-page-footer-control id="confirm-changes-button" [label]="'woa.button.order.confirmChanges'"
                (onActivate)="dismiss(plgItem())"></woa-button>
</woa-modal-page-layout>
